export default __webpack_public_path__ + "static/media/Upload_3.afd10644.png";